module.exports = __webpack_public_path__ + "img/3.55bb1bc9.png";